<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";
import Password from "@/components/widgets/input-password";

export default {
  locales: {
    pt: {
      CHANGE: "ALTERAR",
      "CNPJ is required.": "CNPJ é obrigatório",
      Password: "Senha",
      "Log In": "Entrar",
      "The CNPJ and/or password is incorrect.":
        "O CNPJ e/ou a senha estão incorretos.",
      "The login was successful.": "O login foi efetuado com sucesso.",
      "Forgot your password?": "Esqueceu sua senha?",
      "Don't have an account?": "Não possui uma conta?",
      "Signup now": "Cadastre-se",
    },
    es: {
      CHANGE: "CAMBIAR",
      "CNPJ is required.": "Se requiere CNPJ",
      Password: "Contraseña",
      "Log In": "Iniciar sesión",
      "The CNPJ and/or password is incorrect.":
        "El CNPJ y/o contraseña son incorrectos.",
      "The login was successful.": "El inicio de sesión fue exitoso.",
      "Forgot your password?": "¿Olvidaste tu contraseña?",
      "Don't have an account?": "¿No tienes una cuenta?",
      "Signup now": "Regístrate ahora",
    },
  },
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      language: "en",

      cnpj: "",
      password: "",
      loading: false,
      submitted: false,

      user: {
        name: "",
        cnpj: "",
        avatar: "",
      },
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  validations: {
    cnpj: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { cnpj, password } = this;
        if (cnpj && password) {
          this.alert.type = "";
          this.alert.message = "";
          this.loading = true;
          this.$v.$reset();
          this.login({ cnpj, password });
        }
      }
    },
    clearUser() {
      this.cnpj = "";
      this.user.cnpj = "";
    },
  },
  mounted() {
    if (this.$store.state.account.user) {
      this.cnpj = this.$store.state.account.user.cnpj;
      this.user.cnpj = this.$store.state.account.user.cnpj;
    }
  },
  watch: {
    "alert.type": function (alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 text-center">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 150px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <div class="border rounded py-3 mb-4">
            <h5 class="m-0 font-size-14 font-weight-normal text-uppercase text-center">
              Área dos <strong>Parceiros</strong>
            </h5>
          </div>
          <b-form @submit.prevent="handleSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ t(alert.message) }}
            </div>
            <b-form-group label="CNPJ" label-for="cnpj">
              <b-form-input v-model="cnpj" type="text" :class="{ 'is-invalid': submitted && $v.cnpj.$error }" v-mask="'##.###.###/####-##'"></b-form-input>
              <div v-if="submitted && !$v.cnpj.required" class="invalid-feedback">
                O CNPJ é obrigatório.
              </div>
            </b-form-group>
            <b-form-group label="Senha" label-for="password">
              <Password v-model="password" :v="$v.password"></Password>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                Entrar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </div>
            <div class="mt-4">
              <router-link tag="a" to="/password-forgot" class="text-muted">
                <i class="mdi mdi-lock mr-1"></i>
                Esqueceu sua senha?
              </router-link>
            </div>
          </b-form>
          <div class="mt-2">
            <Languages class="d-none" type="dropup"></Languages>
            <p class="m2n-logo font-size-12 text-uppercase text-muted text-center">
              <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=multiversobrasil.com&utm_medium=link&utm_campaign=logo">
                TECNOLOGIA POR M2N
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block">
      </div>
    </div>
  </Layout>
</template>